import { render, staticRenderFns } from "./CartSaveForLater.vue?vue&type=template&id=3f8740c2&"
import script from "./CartSaveForLater.vue?vue&type=script&lang=js&"
export * from "./CartSaveForLater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports